export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api'
export const IS_DEV = import.meta.env.DEV
export const IS_PROD = import.meta.env.PROD
export const FB_APP_ID = import.meta.env.VITE_FB_APP_ID as string
export const FB_APP_CONFIG_ID = import.meta.env.VITE_FB_APP_CONFIG_ID as string
export const CHAT_SOCKET_URL = import.meta.env.VITE_CHAT_SOCKET_URL as string
